import { FEATURE_FLAGS } from '@/constants/featureFlags';
import {
  J_J_MEDICAL_ABOUT_LEGACY,
  J_J_MEDICAL_ABOUT_MIL,
  J_J_MEDICAL_NAME_LEGACY,
  type PharmaProductSupportTeam,
} from '@/constants/medicalOnDemand';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

type ModTeamCopy = {
  name: string;
  about: string[];
};

/**
 * Returns the `MOD_DIRECT_TO_MSL`-gated team copy (name + sidebar `about`
 * paragraphs) for a full team object. Use in surfaces that render both
 * fields together; otherwise prefer `useModTeamName`.
 *
 * The MIL paragraph is further gated by `MOD_MIL_ROUTE`, matching the MIL
 * checkbox it describes.
 */
export function useModTeamCopy(team: PharmaProductSupportTeam | undefined): ModTeamCopy {
  const isModDirectToMslEnabled = useFeatureFlag(FEATURE_FLAGS.MOD_DIRECT_TO_MSL);

  const isMilEnabled = useFeatureFlag(FEATURE_FLAGS.MOD_MIL_ROUTE);

  if (!team) {
    return { name: '', about: [] };
  }

  if (isModDirectToMslEnabled) {
    const about = isMilEnabled
      ? team.about
      : team.about.filter((paragraph) => paragraph !== J_J_MEDICAL_ABOUT_MIL);

    return { name: team.name, about };
  }

  return { name: J_J_MEDICAL_NAME_LEGACY, about: J_J_MEDICAL_ABOUT_LEGACY };
}
